import { t } from '../i18n';

/**
 * 根据 ResultCode 编码获取国际化翻译。
 *
 * 编码格式：{MODULE}_{ERROR_NAME}，如 "TMS_TASK_NOT_FOUND"
 * i18n key 格式：resultCode.{MODULE}.{ERROR_NAME}，如 "resultCode.TMS.TASK_NOT_FOUND"
 *
 * @param code ResultCode 编码
 * @param fallback 翻译未命中时的兜底文案
 * @returns 翻译后的文案
 */
export function translateResultCode(code: string, fallback?: string): string {
    if (!code || code === '0') return '';
    const idx = code.indexOf('_');
    const module = idx > 0 ? code.substring(0, idx) : code;
    const detail = idx > 0 ? code.substring(idx + 1) : code;
    const key = `resultCode.${module}.${detail}`;
    const translated = t(key);
    return translated !== key ? translated : (fallback || code);
}
